/**
 *   Generated file. Do not edit
 */
import { TapResponse } from '@iotize/tap';
import { SERVICE_CALLS } from './service-calls';

import { LoraConfig } from './models';
import { AbstractService, ServiceCallType } from '@iotize/tap';

export class LoraService extends AbstractService {
  public resources = SERVICE_CALLS;

  /**
   * Get LoRa IDs
   *
   * LWM2M path: /1024//90
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getIds(): Promise<TapResponse<Uint8Array>> {
    return this.serviceCallRunner.execute(this.getIdsCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//90
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getIdsCall(): ServiceCallType {
    const callOptions = { ...this.resources.getIds };

    return callOptions;
  }

  /**
   * Write LoRa IDs
   *
   * LWM2M path: /1024//90
   *
   * @tapVersion(">=1.0")
   * @param value input
   * @return
   */
  putIds(
    /*
     *
     */
    value: Uint8Array,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putIdsCall(value));
  }

  /**
   *
   *
   * LWM2M path: /1024//90
   *
   * @tapVersion(">=1.0")
   * @param value input
   * @return call options
   */
  putIdsCall(
    /*
     *
     */
    value: Uint8Array,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putIds };

    callOptions.body = value;

    return callOptions;
  }

  /**
   * Get LoRa configuration
   *
   * LWM2M path: /1024//91
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getConfig(): Promise<TapResponse<LoraConfig>> {
    return this.serviceCallRunner.execute(this.getConfigCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//91
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getConfigCall(): ServiceCallType {
    const callOptions = { ...this.resources.getConfig };

    return callOptions;
  }

  /**
   * Write LoRa configuration
   *
   * LWM2M path: /1024//91
   *
   * @tapVersion(">=1.0")
   * @param value input
   * @return
   */
  putConfig(
    /*
     *
     */
    value: LoraConfig,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putConfigCall(value));
  }

  /**
   *
   *
   * LWM2M path: /1024//91
   *
   * @tapVersion(">=1.0")
   * @param value input
   * @return call options
   */
  putConfigCall(
    /*
     *
     */
    value: LoraConfig,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putConfig };

    callOptions.body = value;

    return callOptions;
  }
}
